import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/reservation-phase';

const phaseList = (systemSource, merchantId, branchId, data) => {
	return Client.get(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}`),
		data
	);
};

const addPhase = (systemSource, merchantId, branchId, data) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}`),
		data
	);
};

const updatePhase = (systemSource, merchantId, branchId, id, data) => {
	return Client.put(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/${branchId}/${id}`),
		data
	);
};

export default {
	phaseList,
	addPhase,
	updatePhase,
};
